import { oids } from "@/configs/Settings";
import { APPC_CONSENT } from "@/services/appc";
import { GetRelatedPerson } from "./GetRelatedPerson";
import { PatchRelatedPerson } from "./PatchRelatedPerson";

export function getRelatedPersonResourceId(entry: any): string | undefined {
  return entry?.resource?.id;
}

export function getRelatedPersonIdentifierValue(entry: any): string | undefined {
  return entry?.resource?.identifier?.[0]?.value;
}

/** Inativo pendente de verificação (mesmo critério da agenda/atendimento). */
export function isInactivePendingRelatedPerson(entry: any): boolean {
  return Boolean(
    entry?.resource?.identifier &&
      !entry?.resource?.active &&
      entry?.resource?.period?.start
  );
}

export function splitRelatedPersonEntries(
  entries: any[] = [],
  dismissedIds: string[] = []
) {
  const activeRelated = entries.filter((el) => el?.resource?.active === true);
  const inactiveRelated = entries.filter(
    (el) =>
      isInactivePendingRelatedPerson(el) &&
      !dismissedIds.includes(getRelatedPersonResourceId(el) ?? "")
  );

  return { activeRelated, inactiveRelated };
}

export async function fetchPatientRelatedPersons(
  patientCpf: string,
  dismissedIds: string[] = []
) {
  const response = await GetRelatedPerson({
    patient: `${oids.cpf}-${patientCpf.replace(/[.-]/g, "")}`,
  });

  return splitRelatedPersonEntries(response?.data?.entry ?? [], dismissedIds);
}

export async function verifyRelatedPerson({
  relatedPersonId,
  patientId,
  subjectId,
}: {
  relatedPersonId: string;
  patientId: string;
  subjectId: string;
}) {
  await PatchRelatedPerson({
    id: relatedPersonId,
    operation: "replace",
    path: "/active",
    content: true,
  });

  await APPC_CONSENT({
    rule: "Permit",
    patient_id: patientId,
    subject_id: [subjectId],
    cnes: null,
    vigency: null,
    purposeofuse: "PWATRNY",
  });
}

export async function denyRelatedPerson(relatedPersonId: string) {
  await PatchRelatedPerson({
    id: relatedPersonId,
    operation: "replace",
    path: "/active",
    content: false,
  });
}
